/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediaFilesLookupRequest
 */
export interface MediaFilesLookupRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaFilesLookupRequest
     */
    query: string;
}

export function MediaFilesLookupRequestFromJSON(json: any): MediaFilesLookupRequest {
    return MediaFilesLookupRequestFromJSONTyped(json, false);
}

export function MediaFilesLookupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFilesLookupRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'query': json['query'],
    };
}

export function MediaFilesLookupRequestToJSON(value?: MediaFilesLookupRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'query': value.query,
    };
}


